  // Helper function to format session expiration time
  export const getSessionTimeRemaining = (sessionExpireAt: string | undefined): string => {
    if (!sessionExpireAt) return "Unknown";
    
    try {
      const expirationDate = new Date(sessionExpireAt);
      const now = new Date();
      const timeDifference = expirationDate.getTime() - now.getTime();
      
      if (timeDifference <= 0) {
        return "Expired";
      }
      
      // Calculate time components
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      
      // Format based on time remaining
      if (days > 0) {
        return `${days}d ${hours}h`;
      } else if (hours > 0) {
        return `${hours}h ${minutes}m`;
      } else {
        return `${minutes}m`;
      }
    } catch (error) {
      console.error("Error parsing session expiration:", error);
      return "Unknown";
    }
  };